import React from "react";
import { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import { OfferStatusEnum } from "../../../../models/common/Enums";
import { GetAntrepoOfferByIdResponseAntrepoOfferDetail } from "../../../../models/response/antrepoOffer/GetAntrepoOfferByIdResponse";

interface Props {
    changeOfferStatus: (_newStatus: string) => Promise<void>
    isDisabled: boolean
    selectedOfferStatus: CustomSingleSelectModel | undefined
    saveAgreement: () => void
    canCreateAgreement: boolean
    antrepoOfferDetails: GetAntrepoOfferByIdResponseAntrepoOfferDetail[]
}

const ActionButtons = ({
    changeOfferStatus,
    isDisabled,
    selectedOfferStatus,
    saveAgreement,
    canCreateAgreement,
    antrepoOfferDetails
}: Props) => {
    return (
        <React.Fragment>
            {
                (canCreateAgreement && antrepoOfferDetails.filter(x => x.isSelected).length > 0) && (
                    <div className='m-0'>
                        <a
                            onClick={saveAgreement}
                            className='btn btn-sm fw-bold text-white'
                            style={{ background: 'purple' }}
                        >
                            <i className="fa fa-plus-circle text-white"></i>&nbsp;Anlaşma Oluştur
                        </a>
                    </div>
                )
            }

            {
                !isDisabled && (
                    <React.Fragment>
                        <div className='m-0'>
                            <a
                                onClick={() => changeOfferStatus(OfferStatusEnum.ONAYLANDI)}
                                className='btn btn-sm fw-bold btn-success'
                            >
                                <i className="fa fa-check"></i>&nbsp;Sipariş Oluştur
                            </a>
                        </div>

                        <div className='m-0'>
                            <a
                                onClick={() => changeOfferStatus(OfferStatusEnum.REDDEDILDI)}
                                className='btn btn-sm fw-bold btn-danger'
                            >
                                <i className="fa fa-times"></i>&nbsp;Onaylanmadı
                            </a>
                        </div>

                        <div className='m-0'>
                            <a
                                onClick={() => changeOfferStatus(OfferStatusEnum.REVIZE_EDILDI)}
                                className='btn btn-sm fw-bold text-white' style={{ background: 'orange' }}
                            >
                                <i className="fa fa-refresh text-white"></i>&nbsp;Revize
                            </a>
                        </div>
                    </React.Fragment>
                )
            }

        </React.Fragment>
    )
}

export default ActionButtons;